var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlobMulti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 830 800",
    style: {
      enableBackground: "new 0 0 830 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.1;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFC8DD;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#99C7D7;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#F8ABEB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M840.9,515.7c-4.2,102.8-256.2,159-351.4,172.6c-84.7,12.2-202.1,13.3-214.9-33.3 c-11.6-42.4,70.7-99.2,57.2-131.3c-15.1-36-127.5,13.5-138.1-12.8c-11.3-28,90.2-149.8,221.7-186.2 C611.8,270.6,845,415,840.9,515.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,348C9.5,271.7,206.1,126.4,283,77c68.4-43.9,168.7-93.4,196-65c24.9,25.9-25.9,101.3-3,119 c25.6,19.9,104.7-62.7,123-48c19.6,15.7-24.8,146.1-125,227C324.5,430.7,73.8,422.7,42,348z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.9,222.8c-1.5-23.7-4-90.9,21.6-99.1C84.3,105.1,177.3,421.3,340.1,434c158.6,12.4,273-272,314.9-254 c55.7,24-32.7,575.6-260.3,602C207.1,803.8,19.7,457.8,4.9,222.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobMulti);
export default __webpack_public_path__ + "static/media/blobMulti.b50a85f24e2cb755289cbc3fb4f578a0.svg";
export { ForwardRef as ReactComponent };